//@flow

import {combineReducers} from 'redux';
import {simpleReducer} from './reducerHelpers';
import firebaseListeners from './firebaseListeners'
import {
  createFirebaseReducer_array,
  createFirebaseReducer_object,
  createDataStatusReducer } from './reducerHelpers';
import ui from './ui'
import auth from './auth'
import type { Ui } from './ui'
import type { FirebaseListeners } from './firebaseListeners'


export type RootReducer = {
	firebaseInitialized: null | true,
	firebaseListeners: FirebaseListeners,
  coins: [{ name?: string, symbol?: string, twitter: string }],
	ui: Ui
}

const appReducer = combineReducers({
	firebaseInitialized: simpleReducer({'FIREBASE_INITIALIZED': true}),
	firebaseListeners,
  coins: createFirebaseReducer_array('coins'),
  coinsDataStatus: createDataStatusReducer('coins'),
  counts: createFirebaseReducer_object('counts'),
  currentCount: createFirebaseReducer_object('currentCount'),
  priceData: createFirebaseReducer_object('priceData'),
  redditMentions: createFirebaseReducer_array('redditMentions'),
  redditMentionsSub: createFirebaseReducer_array('redditMentionsSub'),
  countsDataStatus: createDataStatusReducer('counts'),
  currentCountDataStatus: createDataStatusReducer('currentCount'),
  priceDataDataStatus: createDataStatusReducer('priceData'),
  redditMentionsDataStatus: createDataStatusReducer('redditMentions'),
  redditMentionsSubDataStatus: createDataStatusReducer('redditMentionsSub'),
  mCaps: createFirebaseReducer_object('mCaps'),
  user: createFirebaseReducer_object('user'),
  userDataStatus: createDataStatusReducer('user'),
  priceInSatoshi: simpleReducer({'SET_PRICE_IN_SATOSHI': 'PAYLOAD'}),
  auth,
	ui
})

// this is to get a clean Store after logout
const rootReducer = (state: any, action: {}) => {
  if (action.type === 'USER_LOGGED_OUT') {
    state = undefined
  }
  return appReducer(state, action)
}

export default rootReducer

//export default (state: {}, action: {}) => state



// WEBPACK FOOTER //
// ./src/reducers/index.js